module.exports = __webpack_public_path__ + "img/my girls the cutest.8e906510.png";